import assign from 'object-assign';
import * as types from '../../constants/K007/ActionTypes';
import * as comTypes from '../../constants/common/ActionTypes';
import * as dispTypes from '../../constants/common/ConstDispTypes';
import * as defaultValue from '../../constants/common/ConstDefaultValue';
import * as commonLogic from '../../logic/CommonLogic';
import * as pachiOnlyColumn from '../../constants/K007/PachiOnlyColumn';
import * as slotOnlyColumn from '../../constants/K007/SlotOnlyColumn';
import * as ContextTitle from '../../constants/K007/ContextSortTitle';

/**
 * Reducer
 * @param {*} state
 * @param {*} action
 */
export default function Reducer(state, action) {

  let remainderAPICountNew = state.remainderAPICount;
  let dataPachiNew = {};
  let dataSlotNew = {};
  let dataPachiDayOnNew = []; // push関数を呼びたいので、配列で宣言
  let dataSlotDayOnNew = []; // push関数を呼びたいので、配列で宣言
  let msgIDNew = state.msgID;

  let dispFlgNew = 1;

  let stateItemList = state.itemList;

  let sortKeyNew = '';
  let sortOrderNew = '';
  let sortDayNew = '';

  let dataCntNew = 0;

  switch (action.type) {
    // ローディング中
    case types.LOADING: {
      dispFlgNew = getDispFlg(state.dayFlg, state.pskubun);
      return assign({}, state, {
        remainderAPICount: 1,
        callApiPlanTime: null,
        dispFlg: dispFlgNew,
        msgID: 'M0004',
        scrollEnd: false
      });
    }

    // ローディング中
    case comTypes.UPDATE_LOADING: {
      dispFlgNew = getDispFlg(state.dayFlg, state.pskubun);
      return assign({}, state, {
        remainderAPICount: 1,
        callApiPlanTime: null,
        dispFlg: dispFlgNew,
        msgID: 'M0004',
        error: null,
        scrollEnd: false,
        calledWebFontAPI: false
      });
    }

    // ローディング中 (スクロールの時)
    case comTypes.SCROLL_LOADING: {
      return assign({}, state, {
        remainderAPICount: 1,
        error: null,
        scrollEnd: true,
        calledWebFontAPI: false
      });
    }

    // パチンコ機種別集計データ
    case types.LOADED_PACHI_DATA: {
      if (!state.isViewReload) {
        return assign({}, state, { });
      }
      let dataPachiFoundNew = false;

      checkSort(state, action);
      if (action.data['data'] != null && action.data['data'].length !== 0) {
        dataPachiFoundNew = true;
        remainderAPICountNew--;

        let id = 1;

        dataCntNew = action.data['count'];

        // 平日・休日OFF
        dataPachiNew = action.data['data'].map((row) => {
          let dispRow = {};
          dispRow['id'] = id++;
          dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
          dispRow['kishuid'] = row.model['id'];
          dispRow['kishumei'] = row.model['display_name'];
          dispRow['ps'] = row.model['ps'];
          dispRow['typeId'] = row.model['type']['id'];
          dispRow['newFlag'] = row.model['new_flag'];
          dispRow['p_sensor'] = row.model['p_sensor'];
          if (row.everyday != null) {
            dispRow['koumoku1'] = row.everyday['out'] != null ? row.everyday['out'] : '';
            dispRow['koumoku2'] = row.everyday['uriage'] != null ? row.everyday['uriage'] : '';
            dispRow['koumoku3'] = row.everyday['arari'] != null ? row.everyday['arari'] : '';
            dispRow['koumoku4'] = row.everyday['tama_tanka'] != null ? row.everyday['tama_tanka'] : '';
            dispRow['koumoku5'] = row.everyday['tama_arari'] != null ? row.everyday['tama_arari'] : '';
            dispRow['koumoku6'] = row.everyday['used_machine_price'] != null ? row.everyday['used_machine_price'] : '';
            dispRow['koumoku7'] = row.everyday['zogen_used_machine_price'] != null ? row.everyday['zogen_used_machine_price'] : '';
            dispRow['koumoku8'] = row.everyday['display_heikin_daisu'] != null ? row.everyday['display_heikin_daisu'] : '';
            dispRow['koumoku9'] = row.everyday['start'] != null ? row.everyday['start'] : '';
            dispRow['koumoku10'] = row.everyday['S1'] != null ? row.everyday['S1'] : '';
            dispRow['koumoku11'] = row.everyday['base'] != null ? row.everyday['base'] : '';
            dispRow['koumoku12'] = row.everyday['BY'] != null ? row.everyday['BY'] : '';
            dispRow['koumoku13'] = row.everyday['BYmin'] != null ? row.everyday['BYmin'] : '';
            dispRow['koumoku14'] = row.everyday['T1Y'] != null ? row.everyday['T1Y'] : '';
            dispRow['koumoku15'] = row.everyday['TY'] != null ? row.everyday['TY'] : '';
            dispRow['koumoku16'] = row.everyday['250tama_start'] != null ? row.everyday['250tama_start'] : '';
            dispRow['koumoku17'] = row.everyday['TS'] != null ? row.everyday['TS'] : '';
            dispRow['koumoku18'] = row.everyday['SA'] != null ? row.everyday['SA'] : '';
            dispRow['koumoku19'] = row.everyday['BA'] != null ? row.everyday['BA'] : '';
            dispRow['koumoku20'] = row.everyday['TO'] != null ? row.everyday['TO'] : '';
            dispRow['koumoku21'] = row.everyday['T1O'] != null ? row.everyday['T1O'] : '';
            dispRow['koumoku22'] = row.everyday['kyakutai_ritsu'] != null ? row.everyday['kyakutai_ritsu'] : '';
            dispRow['koumoku23'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
            dispRow['koumoku24'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
            dispRow['koumoku25'] = row.everyday['display_total_daisu'] != null ? row.everyday['display_total_daisu'] : '';
          } else {
            dispRow['koumoku1'] = '';
            dispRow['koumoku2'] = '';
            dispRow['koumoku3'] = '';
            dispRow['koumoku4'] = '';
            dispRow['koumoku5'] = '';
            dispRow['koumoku6'] = '';
            dispRow['koumoku7'] = '';
            dispRow['koumoku8'] = '';
            dispRow['koumoku9'] = '';
            dispRow['koumoku10'] = '';
            dispRow['koumoku11'] = '';
            dispRow['koumoku12'] = '';
            dispRow['koumoku13'] = '';
            dispRow['koumoku14'] = '';
            dispRow['koumoku15'] = '';
            dispRow['koumoku16'] = '';
            dispRow['koumoku17'] = '';
            dispRow['koumoku18'] = '';
            dispRow['koumoku19'] = '';
            dispRow['koumoku20'] = '';
            dispRow['koumoku21'] = '';
            dispRow['koumoku22'] = '';
            dispRow['koumoku23'] = '';
            dispRow['koumoku24'] = '';
            dispRow['koumoku25'] = '';
          }
          return dispRow;
        });

        // 平日・休日ON
        id = 1;
        action.data['data'].map((row) => {
          for (let i = 0; i < 3; i++) {
            let dispRow = {};
            let group;
            let daytype;

            if (i == 0) {
              group = row.weekday;
              daytype = '平日';
            } else if (i == 1) {
              group = row.holiday;
              daytype = '休日';
            } else {
              group = row.everyday;
              daytype = '期間';
            }

            dispRow['id'] = id++;
            dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
            dispRow['kishuid'] = row.model['id'];
            dispRow['kishumei'] = row.model['display_name'];
            dispRow['ps'] = row.model['ps'];
            dispRow['typeId'] = row.model['type']['id'];
            dispRow['daytype'] = daytype;
            dispRow['newFlag'] = row.model['new_flag'];
            dispRow['p_sensor'] = row.model['p_sensor'];
            if (group != null) {
              dispRow['koumoku1'] = group['out'] != null ? group['out'] : '';
              dispRow['koumoku2'] = group['uriage'] != null ? group['uriage'] : '';
              dispRow['koumoku3'] = group['arari'] != null ? group['arari'] : '';
              dispRow['koumoku4'] = group['tama_tanka'] != null ? group['tama_tanka'] : '';
              dispRow['koumoku5'] = group['tama_arari'] != null ? group['tama_arari'] : '';
              dispRow['koumoku6'] = group['used_machine_price'] != null ? group['used_machine_price'] : '';
              dispRow['koumoku7'] = group['zogen_used_machine_price'] != null ? group['zogen_used_machine_price'] : '';
              dispRow['koumoku8'] = group['display_heikin_daisu'] != null ? group['display_heikin_daisu'] : '';
              dispRow['koumoku9'] = group['start'] != null ? group['start'] : '';
              dispRow['koumoku10'] = group['S1'] != null ? group['S1'] : '';
              dispRow['koumoku11'] = group['base'] != null ? group['base'] : '';
              dispRow['koumoku12'] = group['BY'] != null ? group['BY'] : '';
              dispRow['koumoku13'] = group['BYmin'] != null ? group['BYmin'] : '';
              dispRow['koumoku14'] = group['T1Y'] != null ? group['T1Y'] : '';
              dispRow['koumoku15'] = group['TY'] != null ? group['TY'] : '';
              dispRow['koumoku16'] = group['250tama_start'] != null ? group['250tama_start'] : '';
              dispRow['koumoku17'] = group['TS'] != null ? group['TS'] : '';
              dispRow['koumoku18'] = group['SA'] != null ? group['SA'] : '';
              dispRow['koumoku19'] = group['BA'] != null ? group['BA'] : '';
              dispRow['koumoku20'] = group['TO'] != null ? group['TO'] : '';
              dispRow['koumoku21'] = group['T1O'] != null ? group['T1O'] : '';
              dispRow['koumoku22'] = group['kyakutai_ritsu'] != null ? group['kyakutai_ritsu'] : '';
              dispRow['koumoku23'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
              dispRow['koumoku24'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
              dispRow['koumoku25'] = group['display_total_daisu'] != null ? group['display_total_daisu'] : '';
            } else {
              dispRow['koumoku1'] = '';
              dispRow['koumoku2'] = '';
              dispRow['koumoku3'] = '';
              dispRow['koumoku4'] = '';
              dispRow['koumoku5'] = '';
              dispRow['koumoku6'] = '';
              dispRow['koumoku7'] = '';
              dispRow['koumoku8'] = '';
              dispRow['koumoku9'] = '';
              dispRow['koumoku10'] = '';
              dispRow['koumoku11'] = '';
              dispRow['koumoku12'] = '';
              dispRow['koumoku13'] = '';
              dispRow['koumoku14'] = '';
              dispRow['koumoku15'] = '';
              dispRow['koumoku16'] = '';
              dispRow['koumoku17'] = '';
              dispRow['koumoku18'] = '';
              dispRow['koumoku19'] = '';
              dispRow['koumoku20'] = '';
              dispRow['koumoku21'] = '';
              dispRow['koumoku22'] = '';
              dispRow['koumoku23'] = '';
              dispRow['koumoku24'] = '';
              dispRow['koumoku25'] = '';
            }
            dataPachiDayOnNew.push(dispRow);
          }
        });

        // 検索フィルター(グリッド)
        // 機種名
        dataPachiNew = dataPachiNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        dataPachiDayOnNew = dataPachiDayOnNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        if (dataPachiNew.length === 0 || dataPachiDayOnNew.length === 0) {
          msgIDNew = 'M0003';
          return assign({}, state, {
            msgID: msgIDNew,
            remainderAPICount: 1
          });
        }

      } else {
        dataPachiFoundNew = false;
        msgIDNew = 'M0003';   // not found
      }

      return assign({}, state, {
        remainderAPICount: remainderAPICountNew,
        dataPachi: dataPachiNew,
        dataPachiDayOn: dataPachiDayOnNew,
        dataPachiFound: dataPachiFoundNew,
        msgID: msgIDNew,
        dataCnt: dataCntNew,
        offset: defaultValue.DEFAULT_OFFSET,
        usedMachinePriceDataUpdateFlag: action.data['used_machine_price_data_update_flag']
      });
    }

    // パチンコ機種別集計データ
    case types.LOADED_NEXT_PACHI_DATA: {
      if (!state.isViewReload) {
        return assign({}, state, { });
      }
      let dataNextPachiFoundNew = false;
      checkSort(state, action);
      if (action.data['data'] != null && action.data['data'].length !== 0) {
        dataNextPachiFoundNew = true;
        remainderAPICountNew--;

        let id = 1;

        // 平日・休日OFF
        dataPachiNew = action.data['data'].map((row) => {
          let dispRow = {};
          dispRow['id'] = id++;
          dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
          dispRow['kishuid'] = row.model['id'];
          dispRow['kishumei'] = row.model['display_name'];
          dispRow['ps'] = row.model['ps'];
          dispRow['typeId'] = row.model['type']['id'];
          dispRow['newFlag'] = row.model['new_flag'];
          dispRow['p_sensor'] = row.model['p_sensor'];
          if (row.everyday != null) {
            dispRow['koumoku1'] = row.everyday['out'] != null ? row.everyday['out'] : '';
            dispRow['koumoku2'] = row.everyday['uriage'] != null ? row.everyday['uriage'] : '';
            dispRow['koumoku3'] = row.everyday['arari'] != null ? row.everyday['arari'] : '';
            dispRow['koumoku4'] = row.everyday['tama_tanka'] != null ? row.everyday['tama_tanka'] : '';
            dispRow['koumoku5'] = row.everyday['tama_arari'] != null ? row.everyday['tama_arari'] : '';
            dispRow['koumoku6'] = row.everyday['used_machine_price'] != null ? row.everyday['used_machine_price'] : '';
            dispRow['koumoku7'] = row.everyday['zogen_used_machine_price'] != null ? row.everyday['zogen_used_machine_price'] : '';
            dispRow['koumoku8'] = row.everyday['display_heikin_daisu'] != null ? row.everyday['display_heikin_daisu'] : '';
            dispRow['koumoku9'] = row.everyday['start'] != null ? row.everyday['start'] : '';
            dispRow['koumoku10'] = row.everyday['S1'] != null ? row.everyday['S1'] : '';
            dispRow['koumoku11'] = row.everyday['base'] != null ? row.everyday['base'] : '';
            dispRow['koumoku12'] = row.everyday['BY'] != null ? row.everyday['BY'] : '';
            dispRow['koumoku13'] = row.everyday['BYmin'] != null ? row.everyday['BYmin'] : '';
            dispRow['koumoku14'] = row.everyday['T1Y'] != null ? row.everyday['T1Y'] : '';
            dispRow['koumoku15'] = row.everyday['TY'] != null ? row.everyday['TY'] : '';
            dispRow['koumoku16'] = row.everyday['250tama_start'] != null ? row.everyday['250tama_start'] : '';
            dispRow['koumoku17'] = row.everyday['TS'] != null ? row.everyday['TS'] : '';
            dispRow['koumoku18'] = row.everyday['SA'] != null ? row.everyday['SA'] : '';
            dispRow['koumoku19'] = row.everyday['BA'] != null ? row.everyday['BA'] : '';
            dispRow['koumoku20'] = row.everyday['TO'] != null ? row.everyday['TO'] : '';
            dispRow['koumoku21'] = row.everyday['T1O'] != null ? row.everyday['T1O'] : '';
            dispRow['koumoku22'] = row.everyday['kyakutai_ritsu'] != null ? row.everyday['kyakutai_ritsu'] : '';
            dispRow['koumoku23'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
            dispRow['koumoku24'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
            dispRow['koumoku25'] = row.everyday['display_total_daisu'] != null ? row.everyday['display_total_daisu'] : '';
          } else {
            dispRow['koumoku1'] = '';
            dispRow['koumoku2'] = '';
            dispRow['koumoku3'] = '';
            dispRow['koumoku4'] = '';
            dispRow['koumoku5'] = '';
            dispRow['koumoku6'] = '';
            dispRow['koumoku7'] = '';
            dispRow['koumoku8'] = '';
            dispRow['koumoku9'] = '';
            dispRow['koumoku10'] = '';
            dispRow['koumoku11'] = '';
            dispRow['koumoku12'] = '';
            dispRow['koumoku13'] = '';
            dispRow['koumoku14'] = '';
            dispRow['koumoku15'] = '';
            dispRow['koumoku16'] = '';
            dispRow['koumoku17'] = '';
            dispRow['koumoku18'] = '';
            dispRow['koumoku19'] = '';
            dispRow['koumoku20'] = '';
            dispRow['koumoku21'] = '';
            dispRow['koumoku22'] = '';
            dispRow['koumoku23'] = '';
            dispRow['koumoku24'] = '';
            dispRow['koumoku25'] = '';
          }
          return dispRow;
        });

        // 平日・休日ON
        id = 1;
        action.data['data'].map((row) => {
          for (let i = 0; i < 3; i++) {
            let dispRow = {};
            let group;
            let daytype;

            if (i == 0) {
              group = row.weekday;
              daytype = '平日';
            } else if (i == 1) {
              group = row.holiday;
              daytype = '休日';
            } else {
              group = row.everyday;
              daytype = '期間';
            }

            dispRow['id'] = id++;
            dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
            dispRow['kishuid'] = row.model['id'];
            dispRow['kishumei'] = row.model['display_name'];
            dispRow['ps'] = row.model['ps'];
            dispRow['typeId'] = row.model['type']['id'];
            dispRow['daytype'] = daytype;
            dispRow['newFlag'] = row.model['new_flag'];
            dispRow['p_sensor'] = row.model['p_sensor'];
            if (group != null) {
              dispRow['koumoku1'] = group['out'] != null ? group['out'] : '';
              dispRow['koumoku2'] = group['uriage'] != null ? group['uriage'] : '';
              dispRow['koumoku3'] = group['arari'] != null ? group['arari'] : '';
              dispRow['koumoku4'] = group['tama_tanka'] != null ? group['tama_tanka'] : '';
              dispRow['koumoku5'] = group['tama_arari'] != null ? group['tama_arari'] : '';
              dispRow['koumoku6'] = group['used_machine_price'] != null ? group['used_machine_price'] : '';
              dispRow['koumoku7'] = group['zogen_used_machine_price'] != null ? group['zogen_used_machine_price'] : '';
              dispRow['koumoku8'] = group['display_heikin_daisu'] != null ? group['display_heikin_daisu'] : '';
              dispRow['koumoku9'] = group['start'] != null ? group['start'] : '';
              dispRow['koumoku10'] = group['S1'] != null ? group['S1'] : '';
              dispRow['koumoku11'] = group['base'] != null ? group['base'] : '';
              dispRow['koumoku12'] = group['BY'] != null ? group['BY'] : '';
              dispRow['koumoku13'] = group['BYmin'] != null ? group['BYmin'] : '';
              dispRow['koumoku14'] = group['T1Y'] != null ? group['T1Y'] : '';
              dispRow['koumoku15'] = group['TY'] != null ? group['TY'] : '';
              dispRow['koumoku16'] = group['250tama_start'] != null ? group['250tama_start'] : '';
              dispRow['koumoku17'] = group['TS'] != null ? group['TS'] : '';
              dispRow['koumoku18'] = group['SA'] != null ? group['SA'] : '';
              dispRow['koumoku19'] = group['BA'] != null ? group['BA'] : '';
              dispRow['koumoku20'] = group['TO'] != null ? group['TO'] : '';
              dispRow['koumoku21'] = group['T1O'] != null ? group['T1O'] : '';
              dispRow['koumoku22'] = group['kyakutai_ritsu'] != null ? group['kyakutai_ritsu'] : '';
              dispRow['koumoku23'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
              dispRow['koumoku24'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
              dispRow['koumoku25'] = group['display_total_daisu'] != null ? group['display_total_daisu'] : '';
            } else {
              dispRow['koumoku1'] = '';
              dispRow['koumoku2'] = '';
              dispRow['koumoku3'] = '';
              dispRow['koumoku4'] = '';
              dispRow['koumoku5'] = '';
              dispRow['koumoku6'] = '';
              dispRow['koumoku7'] = '';
              dispRow['koumoku8'] = '';
              dispRow['koumoku9'] = '';
              dispRow['koumoku10'] = '';
              dispRow['koumoku11'] = '';
              dispRow['koumoku12'] = '';
              dispRow['koumoku13'] = '';
              dispRow['koumoku14'] = '';
              dispRow['koumoku15'] = '';
              dispRow['koumoku16'] = '';
              dispRow['koumoku17'] = '';
              dispRow['koumoku18'] = '';
              dispRow['koumoku19'] = '';
              dispRow['koumoku20'] = '';
              dispRow['koumoku21'] = '';
              dispRow['koumoku22'] = '';
              dispRow['koumoku23'] = '';
              dispRow['koumoku24'] = '';
              dispRow['koumoku25'] = '';
            }
            dataPachiDayOnNew.push(dispRow);
          }
        });

        // 検索フィルター(グリッド)
        // 機種名
        dataPachiNew = dataPachiNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        dataPachiDayOnNew = dataPachiDayOnNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        if (dataPachiNew.length === 0 || dataPachiDayOnNew.length === 0) {
          msgIDNew = 'M0003';
          return assign({}, state, {
            msgID: msgIDNew,
            remainderAPICount: 1
          });
        }

        dataPachiNew = state.dataPachi.concat(dataPachiNew);
        dataPachiDayOnNew = state.dataPachiDayOn.concat(dataPachiDayOnNew);

      } else {
        dataNextPachiFoundNew = false;
        msgIDNew = 'M0003';   // not found
      }
      state.focusFlg = false;

      return assign({}, state, {
        remainderAPICount: remainderAPICountNew,
        dataPachi: dataPachiNew,
        dataPachiDayOn: dataPachiDayOnNew,
        dataPachiFound: dataNextPachiFoundNew,
        msgID: msgIDNew,
        offset: state.offset + K007_LIST_DISPLAY_KISHU_COUNT,
        scrollEnd: false,
        usedMachinePriceDataUpdateFlag: action.data['used_machine_price_data_update_flag']
      });
    }

    // スロット機種別集計データ
    case types.LOADED_SLOT_DATA: {
      if (!state.isViewReload) {
        return assign({}, state, { });
      }
      let dataSlotFoundNew = false;
      checkSort(state, action);

      if (action.data['data'] != null && action.data['data'].length !== 0) {
        dataSlotFoundNew = true;
        remainderAPICountNew--;

        let id = 1;

        dataCntNew = action.data['count'];

        // 平日・休日OFF
        dataSlotNew = action.data['data'].map((row) => {
          let dispRow = {};
          dispRow['id'] = id++;
          dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
          dispRow['kishuid'] = row.model['id'];
          dispRow['kishumei'] = row.model['display_name'];
          dispRow['ps'] = row.model['ps'];
          dispRow['typeId'] = row.model['type']['id'];
          dispRow['newFlag'] = row.model['new_flag'];
          dispRow['p_sensor'] = row.model['p_sensor'];
          if (row.everyday != null) {
            dispRow['koumoku1'] = row.everyday['out'] != null ? row.everyday['out'] : '';
            dispRow['koumoku2'] = row.everyday['uriage'] != null ? row.everyday['uriage'] : '';
            dispRow['koumoku3'] = row.everyday['arari'] != null ? row.everyday['arari'] : '';
            dispRow['koumoku4'] = row.everyday['tama_tanka'] != null ? row.everyday['tama_tanka'] : '';
            dispRow['koumoku5'] = row.everyday['tama_arari'] != null ? row.everyday['tama_arari'] : '';
            dispRow['koumoku6'] = row.everyday['used_machine_price'] != null ? row.everyday['used_machine_price'] : '';
            dispRow['koumoku7'] = row.everyday['zogen_used_machine_price'] != null ? row.everyday['zogen_used_machine_price'] : '';
            dispRow['koumoku8'] = row.everyday['display_heikin_daisu'] != null ? row.everyday['display_heikin_daisu'] : '';
            dispRow['koumoku9'] = row.everyday['heikin_dankai_settei'] != null ? row.everyday['heikin_dankai_settei'] : '';
            dispRow['koumoku10'] = row.everyday['dedama_ritsu'] != null ? row.everyday['dedama_ritsu'] : '';
            dispRow['koumoku11'] = row.everyday['game_50mai'] != null ? row.everyday['game_50mai'] : '';
            dispRow['koumoku12'] = row.everyday['TY'] != null ? row.everyday['TY'] : '';
            dispRow['koumoku13'] = row.everyday['saidai_dedamasu'] != null ? row.everyday['saidai_dedamasu'] : '';
            dispRow['koumoku14'] = row.everyday['saidai_suikomisu'] != null ? row.everyday['saidai_suikomisu'] : '';
            dispRow['koumoku15'] = row.everyday['kyakutai_ritsu'] != null ? row.everyday['kyakutai_ritsu'] : '';
            dispRow['koumoku16'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
            dispRow['koumoku17'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
            dispRow['koumoku18'] = row.everyday['display_total_daisu'] != null ? row.everyday['display_total_daisu'] : '';
          } else {
            dispRow['koumoku1'] = '';
            dispRow['koumoku2'] = '';
            dispRow['koumoku3'] = '';
            dispRow['koumoku4'] = '';
            dispRow['koumoku5'] = '';
            dispRow['koumoku6'] = '';
            dispRow['koumoku7'] = '';
            dispRow['koumoku8'] = '';
            dispRow['koumoku9'] = '';
            dispRow['koumoku10'] = '';
            dispRow['koumoku11'] = '';
            dispRow['koumoku12'] = '';
            dispRow['koumoku13'] = '';
            dispRow['koumoku14'] = '';
            dispRow['koumoku15'] = '';
            dispRow['koumoku16'] = '';
            dispRow['koumoku17'] = '';
            dispRow['koumoku18'] = '';
          }
          return dispRow;
        });

        // 平日・休日ON
        id = 1;
        action.data['data'].map((row) => {
          for (let i = 0; i < 3; i++) {
            let dispRow = {};
            let group;
            let daytype;

            if (i == 0) {
              group = row.weekday;
              daytype = '平日';
            } else if (i == 1) {
              group = row.holiday;
              daytype = '休日';
            } else {
              group = row.everyday;
              daytype = '期間';
            }

            dispRow['id'] = id++;
            dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
            dispRow['kishuid'] = row.model['id'];
            dispRow['kishumei'] = row.model['display_name'];
            dispRow['ps'] = row.model['ps'];
            dispRow['typeId'] = row.model['type']['id'];
            dispRow['daytype'] = daytype;
            dispRow['newFlag'] = row.model['new_flag'];
            dispRow['p_sensor'] = row.model['p_sensor'];
            if (group != null) {
              dispRow['koumoku1'] = group['out'] != null ? group['out'] : '';
              dispRow['koumoku2'] = group['uriage'] != null ? group['uriage'] : '';
              dispRow['koumoku3'] = group['arari'] != null ? group['arari'] : '';
              dispRow['koumoku4'] = group['tama_tanka'] != null ? group['tama_tanka'] : '';
              dispRow['koumoku5'] = group['tama_arari'] != null ? group['tama_arari'] : '';
              dispRow['koumoku6'] = group['used_machine_price'] != null ? group['used_machine_price'] : '';
              dispRow['koumoku7'] = group['zogen_used_machine_price'] != null ? group['zogen_used_machine_price'] : '';
              dispRow['koumoku8'] = group['display_heikin_daisu'] != null ? group['display_heikin_daisu'] : '';
              dispRow['koumoku9'] = group['heikin_dankai_settei'] != null ? group['heikin_dankai_settei'] : '';
              dispRow['koumoku10'] = group['dedama_ritsu'] != null ? group['dedama_ritsu'] : '';
              dispRow['koumoku11'] = group['game_50mai'] != null ? group['game_50mai'] : '';
              dispRow['koumoku12'] = group['TY'] != null ? group['TY'] : '';
              dispRow['koumoku13'] = group['saidai_dedamasu'] != null ? group['saidai_dedamasu'] : '';
              dispRow['koumoku14'] = group['saidai_suikomisu'] != null ? group['saidai_suikomisu'] : '';
              dispRow['koumoku15'] = group['kyakutai_ritsu'] != null ? group['kyakutai_ritsu'] : '';
              dispRow['koumoku16'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
              dispRow['koumoku17'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
              dispRow['koumoku18'] = group['display_total_daisu'] != null ? group['display_total_daisu'] : '';
            } else {
              dispRow['koumoku1'] = '';
              dispRow['koumoku2'] = '';
              dispRow['koumoku3'] = '';
              dispRow['koumoku4'] = '';
              dispRow['koumoku5'] = '';
              dispRow['koumoku6'] = '';
              dispRow['koumoku7'] = '';
              dispRow['koumoku8'] = '';
              dispRow['koumoku9'] = '';
              dispRow['koumoku10'] = '';
              dispRow['koumoku11'] = '';
              dispRow['koumoku12'] = '';
              dispRow['koumoku13'] = '';
              dispRow['koumoku14'] = '';
              dispRow['koumoku15'] = '';
              dispRow['koumoku16'] = '';
              dispRow['koumoku17'] = '';
              dispRow['koumoku18'] = '';
            }
            dataSlotDayOnNew.push(dispRow);
          }
        });

        // 検索フィルター
        // 機種名
        dataSlotNew = dataSlotNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        dataSlotDayOnNew = dataSlotDayOnNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        if (dataSlotNew.length === 0 || dataSlotDayOnNew.length === 0) {
          msgIDNew = 'M0003';
          return assign({}, state, {
            msgID: msgIDNew,
            remainderAPICount: 1
          });
        }

      } else {
        dataSlotFoundNew = false;
        msgIDNew = 'M0003';   // not found
      }
      return assign({}, state, {
        remainderAPICount: remainderAPICountNew,
        dataSlot: dataSlotNew,
        dataSlotDayOn: dataSlotDayOnNew,
        dataSlotFound: dataSlotFoundNew,
        msgID: msgIDNew,
        dataCnt: dataCntNew,
        offset: defaultValue.DEFAULT_OFFSET,
        usedMachinePriceDataUpdateFlag: action.data['used_machine_price_data_update_flag']
      });
    }

    // スロット機種別集計データ
    case types.LOADED_NEXT_SLOT_DATA: {
      if (!state.isViewReload) {
        return assign({}, state, { });
      }
      let dataNextSlotFoundNew = false;
      checkSort(state, action);

      if (action.data['data'] != null && action.data['data'].length !== 0) {
        dataNextSlotFoundNew = true;
        remainderAPICountNew--;

        let id = 1;

        // 平日・休日OFF
        dataSlotNew = action.data['data'].map((row) => {
          let dispRow = {};
          dispRow['id'] = id++;
          dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
          dispRow['kishuid'] = row.model['id'];
          dispRow['kishumei'] = row.model['display_name'];
          dispRow['ps'] = row.model['ps'];
          dispRow['typeId'] = row.model['type']['id'];
          dispRow['newFlag'] = row.model['new_flag'];
          dispRow['p_sensor'] = row.model['p_sensor'];
          if (row.everyday != null) {
            dispRow['koumoku1'] = row.everyday['out'] != null ? row.everyday['out'] : '';
            dispRow['koumoku2'] = row.everyday['uriage'] != null ? row.everyday['uriage'] : '';
            dispRow['koumoku3'] = row.everyday['arari'] != null ? row.everyday['arari'] : '';
            dispRow['koumoku4'] = row.everyday['tama_tanka'] != null ? row.everyday['tama_tanka'] : '';
            dispRow['koumoku5'] = row.everyday['tama_arari'] != null ? row.everyday['tama_arari'] : '';
            dispRow['koumoku6'] = row.everyday['used_machine_price'] != null ? row.everyday['used_machine_price'] : '';
            dispRow['koumoku7'] = row.everyday['zogen_used_machine_price'] != null ? row.everyday['zogen_used_machine_price'] : '';
            dispRow['koumoku8'] = row.everyday['display_heikin_daisu'] != null ? row.everyday['display_heikin_daisu'] : '';
            dispRow['koumoku9'] = row.everyday['heikin_dankai_settei'] != null ? row.everyday['heikin_dankai_settei'] : '';
            dispRow['koumoku10'] = row.everyday['dedama_ritsu'] != null ? row.everyday['dedama_ritsu'] : '';
            dispRow['koumoku11'] = row.everyday['game_50mai'] != null ? row.everyday['game_50mai'] : '';
            dispRow['koumoku12'] = row.everyday['TY'] != null ? row.everyday['TY'] : '';
            dispRow['koumoku13'] = row.everyday['saidai_dedamasu'] != null ? row.everyday['saidai_dedamasu'] : '';
            dispRow['koumoku14'] = row.everyday['saidai_suikomisu'] != null ? row.everyday['saidai_suikomisu'] : '';
            dispRow['koumoku15'] = row.everyday['kyakutai_ritsu'] != null ? row.everyday['kyakutai_ritsu'] : '';
            dispRow['koumoku16'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
            dispRow['koumoku17'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
            dispRow['koumoku18'] = row.everyday['display_total_daisu'] != null ? row.everyday['display_total_daisu'] : '';
          } else {
            dispRow['koumoku1'] = '';
            dispRow['koumoku2'] = '';
            dispRow['koumoku3'] = '';
            dispRow['koumoku4'] = '';
            dispRow['koumoku5'] = '';
            dispRow['koumoku6'] = '';
            dispRow['koumoku7'] = '';
            dispRow['koumoku8'] = '';
            dispRow['koumoku9'] = '';
            dispRow['koumoku10'] = '';
            dispRow['koumoku11'] = '';
            dispRow['koumoku12'] = '';
            dispRow['koumoku13'] = '';
            dispRow['koumoku14'] = '';
            dispRow['koumoku15'] = '';
            dispRow['koumoku16'] = '';
            dispRow['koumoku17'] = '';
            dispRow['koumoku18'] = '';
          }
          return dispRow;
        });

        // 平日・休日ON
        id = 1;
        action.data['data'].map((row) => {
          for (let i = 0; i < 3; i++) {
            let dispRow = {};
            let group;
            let daytype;

            if (i == 0) {
              group = row.weekday;
              daytype = '平日';
            } else if (i == 1) {
              group = row.holiday;
              daytype = '休日';
            } else {
              group = row.everyday;
              daytype = '期間';
            }

            dispRow['id'] = id++;
            dispRow['nohinkaishibi'] = row.model['nohinkaishibi'];
            dispRow['kishuid'] = row.model['id'];
            dispRow['kishumei'] = row.model['display_name'];
            dispRow['ps'] = row.model['ps'];
            dispRow['typeId'] = row.model['type']['id'];
            dispRow['daytype'] = daytype;
            dispRow['newFlag'] = row.model['new_flag'];
            dispRow['p_sensor'] = row.model['p_sensor'];
            if (group != null) {
              dispRow['koumoku1'] = group['out'] != null ? group['out'] : '';
              dispRow['koumoku2'] = group['uriage'] != null ? group['uriage'] : '';
              dispRow['koumoku3'] = group['arari'] != null ? group['arari'] : '';
              dispRow['koumoku4'] = group['tama_tanka'] != null ? group['tama_tanka'] : '';
              dispRow['koumoku5'] = group['tama_arari'] != null ? group['tama_arari'] : '';
              dispRow['koumoku6'] = group['used_machine_price'] != null ? group['used_machine_price'] : '';
              dispRow['koumoku7'] = group['zogen_used_machine_price'] != null ? group['zogen_used_machine_price'] : '';
              dispRow['koumoku8'] = group['display_heikin_daisu'] != null ? group['display_heikin_daisu'] : '';
              dispRow['koumoku9'] = group['heikin_dankai_settei'] != null ? group['heikin_dankai_settei'] : '';
              dispRow['koumoku10'] = group['dedama_ritsu'] != null ? group['dedama_ritsu'] : '';
              dispRow['koumoku11'] = group['game_50mai'] != null ? group['game_50mai'] : '';
              dispRow['koumoku12'] = group['TY'] != null ? group['TY'] : '';
              dispRow['koumoku13'] = group['saidai_dedamasu'] != null ? group['saidai_dedamasu'] : '';
              dispRow['koumoku14'] = group['saidai_suikomisu'] != null ? group['saidai_suikomisu'] : '';
              dispRow['koumoku15'] = group['kyakutai_ritsu'] != null ? group['kyakutai_ritsu'] : '';
              dispRow['koumoku16'] = row.model['brand']['display_name'] != null ? row.model['brand']['display_name'] : '';
              dispRow['koumoku17'] = row.model['type']['display_name'] != null ? row.model['type']['display_name'] : '';
              dispRow['koumoku18'] = group['display_total_daisu'] != null ? group['display_total_daisu'] : '';
            } else {
              dispRow['koumoku1'] = '';
              dispRow['koumoku2'] = '';
              dispRow['koumoku3'] = '';
              dispRow['koumoku4'] = '';
              dispRow['koumoku5'] = '';
              dispRow['koumoku6'] = '';
              dispRow['koumoku7'] = '';
              dispRow['koumoku8'] = '';
              dispRow['koumoku9'] = '';
              dispRow['koumoku10'] = '';
              dispRow['koumoku11'] = '';
              dispRow['koumoku12'] = '';
              dispRow['koumoku13'] = '';
              dispRow['koumoku14'] = '';
              dispRow['koumoku15'] = '';
              dispRow['koumoku16'] = '';
              dispRow['koumoku17'] = '';
              dispRow['koumoku18'] = '';
            }
            dataSlotDayOnNew.push(dispRow);
          }
        });

        // 検索フィルター
        // 機種名
        dataSlotNew = dataSlotNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        dataSlotDayOnNew = dataSlotDayOnNew.filter((item) => {
          return (item['kishumei'].indexOf(state.kishu) != -1);
        });

        if (dataSlotNew.length === 0 || dataSlotDayOnNew.length === 0) {
          msgIDNew = 'M0003';
          return assign({}, state, {
            msgID: msgIDNew,
            remainderAPICount: 1
          });
        }

        dataSlotNew = state.dataSlot.concat(dataSlotNew);
        dataSlotDayOnNew = state.dataSlotDayOn.concat(dataSlotDayOnNew);

      } else {
        dataNextSlotFoundNew = false;
        msgIDNew = 'M0003';   // not found
      }
      state.focusFlg = false;
      return assign({}, state, {
        remainderAPICount: remainderAPICountNew,
        dataSlot: dataSlotNew,
        dataSlotDayOn: dataSlotDayOnNew,
        dataSlotFound: dataNextSlotFoundNew,
        msgID: msgIDNew,
        offset: state.offset + K007_LIST_DISPLAY_KISHU_COUNT,
        scrollEnd: false,
        usedMachinePriceDataUpdateFlag: action.data['used_machine_price_data_update_flag']
      });
    }

    // TODO 絞り込み条件: 反映ボタン
    case comTypes.FILTER_FORM_APPLY: {
      console.log("反映");

      return assign({}, state, {
      });
    }

    // 平日・休日表示
    case comTypes.CHANGE_DAY: {
      let sortKey = state.sortKey;
      let sortOrder = state.sortOrder;
      let sortDay = state.sortDay;

      if (action.value == '0') {
        if (state.sortDay == 'weekday' || state.sortDay == 'holiday') {
          sortKey = 'out';
          sortOrder = 'desc';
          sortDay = 'everyday';
        }
      }
      return assign({}, state, {
        dayFlg: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false,
        sortKey: sortKey,
        sortOrder: sortOrder,
        sortDay: sortDay,
      });
    }

    // パチンコ・スロット
    case comTypes.CHANGE_PSKUBUN: {
      let pskubunNew = action.value;
      let sortKey = state.sortKey;
      let sortOrder = state.sortOrder;
      let sortDay = state.sortDay;

      if (pskubunNew == defaultValue.PS_PACHINKO) {
        for (let i = 0; i < slotOnlyColumn.SLOT_ONLY_COLUMN.length; i++) {
          if (sortKey == slotOnlyColumn.SLOT_ONLY_COLUMN[i]) {
            sortKey = 'out';
            sortOrder = 'desc';
            sortDay = 'everyday';
            break;
          }
        }

        return assign({}, state, {
          pskubun: action.value,
          rate: defaultValue.DEFAULT_PACHI_RATE,
          type: defaultValue.DEFAULT_TYPE,
          callApiPlanTime: action.time,
          scrollEnd: false,
          sortKey: sortKey,
          sortOrder: sortOrder,
          sortDay: sortDay,
        });

      } else {
        for (let i = 0; i < pachiOnlyColumn.PACHI_ONLY_COLUMN.length; i++) {
          if (sortKey == pachiOnlyColumn.PACHI_ONLY_COLUMN[i]) {
            sortKey = 'out';
            sortOrder = 'desc';
            sortDay = 'everyday';
            break;
          }
        }
        return assign({}, state, {
          pskubun: action.value,
          rate: defaultValue.DEFAULT_SLOT_RATE,
          type: defaultValue.DEFAULT_TYPE,
          callApiPlanTime: action.time,
          scrollEnd: false,
          sortKey: sortKey,
          sortOrder: sortOrder,
          sortDay: sortDay,
        });
      }
    }

    case types.SCROLL: {
      return assign({}, state, {
        remainderAPICount: 1,
        msgID: 'M0004',
        scrollTop: action.value,
      });
    }


    // レート表示データ読み込み
    case comTypes.LOADED_RATE: {
      // 種別のリストを設定
      if (action.itemList.rateList.pachinkoList.length !== 0 &&
        action.itemList.rateList.slotList.length !== 0) {
        stateItemList.rateList = action.itemList.rateList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // PS区分変更
    case comTypes.CHANGE_RATE: {
      return assign({}, state, {
        rate: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // PS&レート変更
    case comTypes.CHANGE_PS_RATE: {
      let pskubunNew = action.pskubun;
      let rateNew = action.rate;
      let sortKey = action.sortKey;
      let sortOrder = state.sortOrder;
      return assign({}, state, {
        pskubun: pskubunNew,
        rate: rateNew,
        sortKey: sortKey,
        sortOrder: sortOrder,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // タイプ表示データ読み込み
    case comTypes.LOADED_TYPE: {
      // タイプのリストを設定
      if (action.itemList.typeList.slotList.length !== 0 &&
        action.itemList.typeList.pachinkoList.length !== 0) {
        stateItemList.typeList = action.itemList.typeList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    case comTypes.CHANGE_TYPE: {
      return assign({}, state, {
        type: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // メーカー表示データ読み込み
    case comTypes.LOADED_MAKER: {
      // 種別のリストを設定
      if (action.itemList.makerList.length !== 0) {
        stateItemList.makerList = action.itemList.makerList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // メーカーリスト変更
    case comTypes.CHANGE_MAKER: {
      return assign({}, state, {
        maker: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }
    // 区分表示データ読み込み
    case comTypes.LOADED_KUBUN: {
      // 区分のリストを設定
      if (action.itemList.kubunList.pachinkoList.length !== 0 &&
        action.itemList.kubunList.slotList.length !== 0) {
        stateItemList.kubunList = action.itemList.kubunList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // 区分リスト変更
    case comTypes.CHANGE_KUBUN: {
      return assign({}, state, {
        kubun: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // 機種名変更
    case comTypes.CHANGE_KISHU: {
      return assign({}, state, {
        kishu: action.value,
        callApiPlanTime: null,
        scrollEnd: false,
        focusFlg: false
      });
    }

    // 機種名検索ボタン押下
    case comTypes.CLICK_SEARCH: {
      return assign({}, state, {
        kishu: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // 機種名検索ボタン押下(スマホ)
    case comTypes.CLICK_SEARCH_SUMMARY: {
      return assign({}, state, {
        kishu: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false,
        error: null,
        focusFlg: false
      });
    }

    // 機種名クリアボタン押下
    case comTypes.CLEAR_KISHU: {
      return assign({}, state, {
        kishu: '',
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // 機種名クリアボタン押下(スマホ)
    case comTypes.CLEAR_KISHU_SUMMARY: {
      return assign({}, state, {
        kishu: '',
        callApiPlanTime: action.time,
        scrollEnd: false,
        error: null,
        focusFlg: false
      });
    }

    // 更新ボタン押下
    case types.CLICK_UPDATE: {
      // 準必須チェック
      // すべての準必須項目の選択肢が、「すべて」または未入力の場合にメッセージを表示させる。
      dispFlgNew = getDispFlg(action.dayFlg, action.pskubun);
      return assign({}, state, {
        callApiPlanTime: action.time,
        kubun: action.kubun,  // 区分
        term: commonLogic.getTermFromURL(),  // 期間
        dispFlg: dispFlgNew,
        rate: action.rate,
        pskubun: action.pskubun,
        nohinkaishibi: commonLogic.getNohinURL(),
        nohinkaishibiFrom: commonLogic.getNohinFromURL() || '',
        nohinkaishibiTo: commonLogic.getNohinToURL() || '',
        type: action.condType,
        maker: action.maker,
        kishu: commonLogic.getKishuNameFromURL(),
        gouki: action.gouki,
        smartYugiki: action.smartYugiki,
        yugitype: action.yugitype,
        dayFlg: action.dayFlg,
        sortKey: 'out',  // ソート項目
        sortOrder: 'desc',  // ソート順
        sortDay: 'everyday',
        scrollEnd: false,
        kikanUnit: commonLogic.getKikanUnitFromURL(),
      });
    }

    // 更新ボタン押下で必須チェック
    case types.UPDATE_ERROR: {
      msgIDNew = 'M0005';   // １つ以上で「すべて」、または「未入力」以外を指定してください。
      return assign({}, state, {
        msgID: msgIDNew,
        remainderAPICount: 1,
        callApiPlanTime: null,
        scrollEnd: false
      });
    }

    // 期間読み込み
    case comTypes.LOADED_KIKAN: {
      if (action.termData != null && action.termData.length !== 0) {
        return assign({}, state, {
          term: action.term,
          termData: action.termData,
          termStart: action.termStart,
          termEnd: action.termEnd
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // 納品開始日読み込み
    case comTypes.LOADED_KAISHIBI: {
      if (action.term != null && action.term.length !== 0) {
        return assign({}, state, {
          nohinTermData: action.term,
          nohinkaishibiFrom: action.nohinFrom,
          nohinkaishibiTo: action.nohinTo,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // 機種名検索フォーカス時
    case comTypes.STOP_UPDATE: {
      return assign({}, state, {
        callApiPlanTime: action.time,
        scrollEnd: false,
        focusFlg: false,
      });
    }

    // 機種名検索フォーカスアウト時
    case comTypes.ON_BLUR: {
      return assign({}, state, {
        callApiPlanTime: action.time,
        scrollEnd: false,
        focusFlg: false,
      });
    }

    // 期間変更
    case comTypes.CHANGE_KIKAN: {
      return assign({}, state, {
        term: action.value,
        termStart: action.termStart,
        termEnd: action.termEnd,
        callApiPlanTime: action.time,
        scrollEnd: false,
        isOpenCalendar: false
      });
    }

    // 納品開始日From変更
    case comTypes.CHANGE_KAISHIBI_FROM: {
      return assign({}, state, {
        nohinkaishibiFrom: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false,
        isOpenCalendar: false
      });
    }

    // 納品開始日To変更
    case comTypes.CHANGE_KAISHIBI_TO: {
      return assign({}, state, {
        nohinkaishibiTo: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false,
        isOpenCalendar: false
      });
    }

    // エラー
    case types.ERROR: {
      // 認証エラーの場合は、tokenを再取得する
      // if (action.error.message === '401') {
      //   let reAuthCnt = Number(sessionStorage.getItem('reAuthenticationCnt'));
      //   if (isNaN(reAuthCnt)) reAuthCnt = 0;
      //   if (reAuthCnt < MAX_RE_AUTHENTICATION_CNT) {
      //     reAuthCnt += 1;
      //     sessionStorage.setItem('reAuthenticationCnt', reAuthCnt);
      //     sessionStorage.setItem('recoverLastSearch', true);
      //     authenticator.authorize();
      //     return null;
      //   }
      // }

      const controlErr = action.errPara;
      const errArr = commonLogic.setControlError(controlErr);
      return assign({}, state, { error: action.error, errArray: errArr });
    }

    // エラー
    case comTypes.ERROR_COMMON: {
      // 認証エラーの場合は、tokenを再取得する
      // if (action.error.message === '401') {
      //   let reAuthCnt = Number(sessionStorage.getItem('reAuthenticationCnt'));
      //   if (isNaN(reAuthCnt)) reAuthCnt = 0;
      //   if (reAuthCnt < MAX_RE_AUTHENTICATION_CNT) {
      //     reAuthCnt += 1;
      //     sessionStorage.setItem('reAuthenticationCnt', reAuthCnt);
      //     sessionStorage.setItem('recoverLastSearch', true);
      //     authenticator.authorize();
      //     return null;
      //   }
      // }

      return assign({}, state, { error: action.error, controlErrFlg: false });
    }

    case comTypes.USER_NAME: {
      return assign({}, state, { userName: action.userName });
    }

    case comTypes.RE_RENDER: {
      return assign({}, state, {
        isPc: action.isPc
      });
    }

    case comTypes.CALL_WEB_FONT_API: {
      return assign({}, state, {
        calledWebFontAPI: true
      });
    }

    case comTypes.SELECT_KIKAN: {
      return assign({}, state, {
        term: action.value,
        termStart: action.termStart,
        termEnd: action.termEnd
      });
    }

    case comTypes.SELECT_NOHIN: {
      if (!action.value.includes('p') && !action.value.includes('n')) {
        if (!state.nohinkaishibi.includes('all')) {
          return assign({}, state, {
            nohinkaishibi: action.value,
            preYear: state.nohinkaishibi
          });
        } else {
          return assign({}, state, {
            nohinkaishibi: action.value
          });
        }
      } else {
        if (!state.nohinkaishibi.includes('all')) {
          const nohinkaishibi = action.value.substring(2);
          const flgNextPreButton = action.value.substring(0, 1);
          return assign({}, state, {
            nohinkaishibi: nohinkaishibi,
            flgNextPreButton: flgNextPreButton
          });
        } else {
          const flgNextPreButton = action.value.substring(0, 1);
          return assign({}, state, {
            nohinkaishibi: 'all',
            flgNextPreButton: flgNextPreButton
          });
        }
      }
    }

    case comTypes.OPEN_KIKAN: {
      return assign({}, state, {
        isOpenCalendar: true
      });
    }

    case comTypes.CLOSE_KIKAN: {
      return assign({}, state, {
        term: action.value,
        termStart: action.termStart,
        termEnd: action.termEnd,
        isOpenCalendar: false
      });
    }

    case comTypes.CLOSE_KAISHIBI: {
      return assign({}, state, {
        nohinkaishibi: action.value,
        isOpenCalendar: false
      });
    }

    case comTypes.OPEN_DATEPICKER: {
      return assign({}, state, {
        displayDate: action.displayDate,
        isNohinCalendar: action.isNohinCalendar,
        calendarViewMode: action.viewMode,
        isFromDatePicker: action.isFromDatePicker,
        isOpenCalendar: true,
      });
    }

    case comTypes.UPDATE_DISPLAY_DATE: {
      return assign({}, state, {
        displayDate: action.displayDate,
      });
    }

    case comTypes.CALENDAR_CANCEL: {
      return assign({}, state, {
        calendarViewMode: action.value,
        isNohinCalendar: false,
        isOpenCalendar: false,
      });
    }

    case comTypes.CHANGE_CALENDAR_VIEW_MODE: {
      return assign({}, state, {
        calendarViewMode: action.value,
      });
    }

    case comTypes.UPDATE_KIKAN_TERM: {
      return assign({}, state, {
        term: action.term,
        termStart: action.termStart,
        termEnd: action.termEnd,
        displayDate: action.displayDate,
        callApiPlanTime: action.time,
        scrollEnd: false,
        isOpenCalendar: false
      });
    }

    case comTypes.CHANGE_KIKAN_UNIT: {
      return assign({}, state, {
        term: action.term,
        termStart: action.termStart,
        termEnd: action.termEnd,
        kikanUnit: action.termUnit,
        calendarViewMode: action.viewMode,
        callApiPlanTime: action.time,
        scrollEnd: false,
        isOpenCalendar: false
      });
    }

    // 遊技タイプ表示データ読み込み
    case comTypes.LOADED_YUGI_TYPE: {
      // 遊技タイプのリストを設定
      if (action.itemList.yugitypeList.length !== 0) {
        stateItemList.yugitypeList = action.itemList.yugitypeList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // 遊技タイプ変更
    case comTypes.CHANGE_YUGI_TYPE: {
      return assign({}, state, {
        yugitype: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // 号機表示データ読み込み
    case comTypes.LOADED_GOUKI: {
      // 号機のリストを設定
      if (action.itemList.goukiList.length !== 0) {
        stateItemList.goukiList = action.itemList.goukiList;
        return assign({}, state, {
          itemList: stateItemList,
        });
      } else {
        const err = new Error(404);
        return assign({}, state, { error: err, controlErrFlg: false });
      }
    }

    // 号機変更
    case comTypes.CHANGE_GOUKI: {
      return assign({}, state, {
        gouki: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // スマート遊技機変更
    case comTypes.CHANGE_SMARTYUGIKI: {
      return assign({}, state, {
        smartYugiki: action.value,
        callApiPlanTime: action.time,
        scrollEnd: false
      });
    }

    // ソート押下
    case types.CLICK_SORT: {
      if (action.sortKey === null) {
        sortKeyNew = 'out';
      } else {
        sortKeyNew = action.sortKey;
      }
      if (action.sortOrder === null) {
        sortOrderNew = 'desc';
      } else {
        sortOrderNew = action.sortOrder;
      }
      if (action.sortDay === null) {
        sortDayNew = 'everyday';
      } else {
        sortDayNew = action.sortDay;
      }

      return assign({}, state, {
        callApiPlanTime: action.time,
        sortKey: sortKeyNew,  // ソート項目
        sortOrder: sortOrderNew,  // ソート順
        sortDay: sortDayNew,  // ソート平日・休日
        scrollEnd: false
      });
    }
    // ソート押下
    case types.CLICK_SORT_SUMMARY: {
      if (action.sortKey === null) {
        sortKeyNew = 'out';
      } else {
        sortKeyNew = action.sortKey;
      }
      if (action.sortOrder === null) {
        sortOrderNew = 'desc';
      } else {
        sortOrderNew = action.sortOrder;
      }
      if (action.sortDay === null) {
        sortDayNew = 'everyday';
      } else {
        sortDayNew = action.sortDay;
      }

      return assign({}, state, {
        callApiPlanTime: action.time,
        sortKey: sortKeyNew,  // ソート項目
        sortOrder: sortOrderNew,  // ソート順
        sortDay: sortDayNew,  // ソート平日・休日
        scrollEnd: false
      });
    }

    // パチンコorスロット機種リスト取得
    case types.LOADED_KISHU_LIST: {
      return assign({}, state, {
        itemList: assign({}, state.itemList, {
          kishuNameList: action.kishuList
        })
      });
    }

    default:
      return state;
  }
}

/**
 * DispFlgを取得
 * @param {*} dayFlg
 */
function getDispFlg(dayFlg, pskubun) {
  if (dayFlg == 0 && pskubun == 0) {
    return dispTypes.DAYOFF_TYPEOFF;
  }
  if (dayFlg == 1 && pskubun == 0) {
    return dispTypes.DAYON_TYPEOFF;
  }
  if (dayFlg == 0 && pskubun == 1) {
    return dispTypes.DAYOFF_TYPEON;
  }
  if (dayFlg == 1 && pskubun == 1) {
    return dispTypes.DAYON_TYPEON;
  }

}

function checkSort(state, action) {
  if (CHECK_SORT_RESPONSE) {
    if (state.sortKey != null) {
      if (action.data['sort'] != null && state.sortKey == action.data['sort'].key) {
        if (state.sortOrder != action.data['sort'].order) {
          throw new Error('指定項目：' + state.sortKey + ' 返却されたソート順が不正です。');
        }
        if (ContextTitle.MODEL_SORT_KEY.includes(state.sortKey)) {
          if ('model' != action.data['sort'].target) {
            throw new Error('指定項目：' + state.sortKey + ' 返却された集計単位が不正です。');
          }
        } else {
          if (state.dayFlg == '1') {
            if (state.sortDay != action.data['sort'].target) {
              throw new Error('指定項目：' + state.sortKey + ' 返却された集計単位（平日休日）が不正です。');
            }
          }
        }
      } else {
        throw new Error('指定項目：' + state.sortKey + ' 返却されたソート順が不正です。');
      }

    } else if (action.data['sort'] != null) {
      throw new Error('指定項目： 返却されたソート順が不正です。');
    }
  }
}
